import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-regular-svg-icons'

const RatingBar = (rating) => {
  return (
    <span className="restaurantRating">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <span className="ml-2"> {parseFloat(rating.rating).toFixed(1)}</span>
    </span>
  )
}

export default RatingBar
